import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Waves } from "lucide-react";
import { BUSINESS } from "../data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-navy-grid text-white mt-12"
      style={{ backgroundColor: "#0B2F6B" }}
    >
      <div className="aqua-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: "#1E7BE0" }}>
                <Waves className="w-5 h-5 text-white" />
              </span>
              <span className="font-script text-2xl">
                Agua Flow Mobile
              </span>
            </div>
            <p className="text-white/75 max-w-md leading-relaxed">
              {BUSINESS.tagline} Premium mobile swim lessons and small-group
              academy classes across Southeast North Carolina — ages 6 months
              to adult.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href={BUSINESS.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full flex items-center justify-center border border-white/20 hover:bg-[#33BED6] hover:border-[#33BED6] transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={BUSINESS.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full flex items-center justify-center border border-white/20 hover:bg-[#33BED6] hover:border-[#33BED6] transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading font-semibold text-base mb-4 text-white">
              Explore
            </h4>
            <ul className="space-y-3 text-white/75 text-sm">
              <li><Link to="/about" className="hover:text-[#33BED6]" data-testid="footer-link-about">About Us</Link></li>
              <li><Link to="/programs" className="hover:text-[#33BED6]" data-testid="footer-link-programs">Our Programs</Link></li>
              <li><Link to="/how-it-works" className="hover:text-[#33BED6]" data-testid="footer-link-how">How It Works</Link></li>
              <li><Link to="/reviews" className="hover:text-[#33BED6]" data-testid="footer-link-reviews">Reviews</Link></li>
              <li><Link to="/faq" className="hover:text-[#33BED6]" data-testid="footer-link-faq">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-[#33BED6]" data-testid="footer-link-contact">Book a Lesson</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-semibold text-base mb-4 text-white">
              Get in Touch
            </h4>
            <ul className="space-y-3 text-white/85 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#33BED6]" />
                <a href={BUSINESS.phoneHref} className="hover:text-[#33BED6]" data-testid="footer-phone">
                  {BUSINESS.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#33BED6]" />
                <a href={BUSINESS.emailHref} className="hover:text-[#33BED6]" data-testid="footer-email">
                  {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#33BED6]" />
                <span>
                  Serving {BUSINESS.serviceAreas.slice(0, -1).join(", ")} {BUSINESS.serviceAreas.at(-1)}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <p>© {new Date().getFullYear()} Agua Flow Mobile. All rights reserved.</p>
          <p className="font-heading">{BUSINESS.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
